export const API_NAME = 'workorder';
export const API_VERSION = 'v1';
export const API_BASE_URL = `${API_NAME}/${API_VERSION}`;

export const DEFAULT_ORDER: 'ASC' | 'DESC' = 'ASC';
export const DEFAULT_ROWS = 10;

export const workorderDicionaryError: Record<string, string> = {
  'workorder.errors.workorder.change.complement.done':
    'Não é possível alterar, pois existem complementos fechados no orçamento',
  'workorder.errors.workorder_auth_item_empty':
    'Os itens não podem estar vazios',
  'ultracar.errors.bad_request': 'Preencha todos os campos obrigatórios',
  'workorder.errors.workorder_stock_status_fail':
    'Houve um problema no status do estoque, tente novamente.',
  'workorder.errors.workorder_has_finished': 'O Orçamento está fechado',
  'workorder.errors.workorder_has_non_finished_complement':
    'O complemento do orçamento não foi finalizado.',
  'workorder.errors.workorder_not_open': 'O complemento está fechado.',
  'ultracar.errors.services.return_greater_than_delivered':
    'A devolução é maior que a entrega.',
  'Unrecognized Guid format.': 'Não foi possível efetuar a requisição.',
  'workorder.errors.workorder_there_is_pending_purchase_of':
    'Item do orçamento pendente de compra',
  'archive.errors.access_forbidden': 'Acesso proibido',
  'ultracar.errors.services.return_less_than_delivered':
    'Existem peças a serem devolvidas',
  'workorder.errors.workorder_there_is_a_linked_purchase':
    'Não foi possível excluir! Este item não pode ser excluido pois existe uma compra referente a ele.',
  'workorder.errors.workorder_there_is_pending_purchase':
    'Existe compra vinculada a esse item.',
  'stock.errors.part_in_quotation': 'Existe cotação vinculada a esse item.',
  'workorder.errors.workorder_there_is_purchase':
    'Existe compra vinculada a esse item.',
};
